import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem('userEmail');
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!userEmail) {
      navigate('/login');
    } else {
      fetch(`https://jivangaming.in/backend/get-purchases.php?email=${userEmail}`)
        .then((res) => res.json())
        
        .then((data) => setHistory(data))
        .catch((err) => console.error("Failed to fetch purchase history:", err));
    }
  }, [userEmail, navigate]);

  return (
    <div className="min-h-screen p-6 bg-gray-100">
      <h1 className="text-3xl font-bold text-center mb-4">Welcome to your Profile</h1>
      <p className="text-center mb-6 text-lg">Logged in as: <strong>{userEmail || 'Guest'}</strong></p>

      <div className="max-w-3xl mx-auto bg-white p-4 rounded shadow">
        <h2 className="text-xl font-semibold mb-3">📦 Your Purchased Courses</h2>
        {history.length === 0 ? (
          <p>No purchases yet.</p>
        ) : (
          <ul className="space-y-4">
            {history.map((item) => (
              <li key={item.id} className="border p-3 rounded bg-gray-50">
                <p><strong>Product:</strong> {item.product_slug}</p>
                <p><strong>Date:</strong> {new Date(item.purchase_date).toLocaleString()}</p>
                <a href={item.download_link} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Download</a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
